import request from '../utils/request';


export const AccountAPI = {
    /**
     * 查询 用户套餐信息
     */
    queryPlanInfos() {
        return request({
            url: "/api/account/user-packages",
            method: "get"
        })
    },
    /**
     * 刷新apiKey
     */
    refreshApiKey() {
        return request({
            method: "POST",
            url: "/api/account/apikey/refresh"
        })
    },
    /**
     * 绑定ApiKey
     */
    bindApiKey(apikey) {
        return request({
            method: "POST",
            url: "/api/account/apikey/bind",
            data: { "apikey": apikey }
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/account.js